export interface IEventChartOptions {
    selectedEventTypeIds: string[];
    selectedGroupingType: string;
    selectedTimeSpan: string;
}

export class EventChartOptions implements IEventChartOptions {
    selectedEventTypeIds: string[];
    selectedGroupingType: string;
    selectedTimeSpan: string;

    constructor();
    constructor(obj: IEventChartOptions);
    constructor(obj?: any) {
        this.selectedEventTypeIds = obj && obj.selectedEventTypeIds || [];
        this.selectedGroupingType = obj && obj.selectedGroupingType || "0";
        this.selectedTimeSpan = obj && obj.selectedTimeSpan || "3";
    }
}